import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sticky-bar d-flex justify-content-between align-items-center"
}
const _hoisted_2 = { class: "flex-grow-1 text-start" }
const _hoisted_3 = { class: "heading mb-1" }
const _hoisted_4 = { class: "heading fw-bold" }

import { computed, ComputedRef } from 'vue'
  import { useI18n } from 'vue-i18n'
  import PaymentButton from '@/components/common/PaymentButton.vue'
  import Price from '@/components/common/Price.vue' // Import PriceComponent
  import { useStore } from '@/store'
  import { BookingStatus } from '@/config'
  import { BookingSummary } from '@/services/BookingService.interface'

  // Composables
  import useScreenSize from '@/composables/useScreenSize'
  import ReserveActionsButton from '@/components/common/ReserveActionsButton.vue'
  import { useBookingFunnelActions } from '@/composables/useBookingFunnelActions'
  import { useBookingFunnelNavigation } from '@/composables/useBookingFunnelNavigation'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'StickyBar',
  props: {
    booking: {
      type: Object as () => BookingSummary,
      required: true,
    },
  },
  setup(__props) {

  const store = useStore()

  const props = __props

  const userId: ComputedRef<string | null> = computed(
    () => store.state.auth?.user?.iresa_id || null
  )

  const { t } = useI18n()

  const showQuoteOrCartBlock = computed(() =>
    [BookingStatus.Quote, BookingStatus.CartInProgress].includes(
      props.booking.status
    )
  )

  const { showReserveButton, showPayBalanceButton } = useBookingFunnelActions(
    () => props.booking
  )
  const { payActionLabel } = useBookingFunnelNavigation(() => props.booking)

  // Methods
  const { isMobile } = useScreenSize()

return (_ctx: any,_cache: any) => {
  return (_unref(isMobile))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (showQuoteOrCartBlock.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('reservations.total')), 1),
                _createElementVNode("p", _hoisted_4, [
                  _createVNode(Price, {
                    price: __props.booking.sellingPrice
                  }, null, 8, ["price"])
                ])
              ]),
              (_unref(showReserveButton))
                ? (_openBlock(), _createBlock(ReserveActionsButton, {
                    key: 0,
                    booking: props.booking,
                    "default-label": _unref(t)('reservations.reserve'),
                    "button-class": "w-40"
                  }, null, 8, ["booking", "default-label"]))
                : (_unref(showPayBalanceButton))
                  ? (_openBlock(), _createBlock(ReserveActionsButton, {
                      key: 1,
                      booking: props.booking,
                      "default-label": _unref(payActionLabel),
                      "button-class": "w-40"
                    }, null, 8, ["booking", "default-label"]))
                  : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createBlock(PaymentButton, {
              key: 1,
              userId: userId.value,
              booking: props.booking
            }, null, 8, ["userId", "booking"]))
      ]))
    : _createCommentVNode("", true)
}
}

})